import { motion } from "framer-motion";
import { ArrowDownRight, Mail } from "lucide-react";
import { MotionWrap, AppWrap } from "../../wrapper";
import { images } from "../../constants";

const ease = [0.22, 1, 0.36, 1];

const Header = () => {
  return (
    <section
      id="home"
      className="mx-auto w-full max-w-5xl px-5 py-6 sm:px-8 sm:py-16 lg:px-12 lg:py-20"
    >
      <div className="flex flex-col gap-4 sm:gap-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7, ease }}
          className="w-[min(160px,38vw)] sm:w-[min(320px,70vw)] aspect-square overflow-hidden rounded-full border border-black/10 bg-black/[0.03]"
        >
          <img
            src={images.profile}
            alt="Reynaldo Domenico portrait"
            loading="eager"
            className="h-full w-full object-cover saturate-95 contrast-[1.02]"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.7, ease, delay: 0.05 }}
          className="max-w-[64ch]"
        >
          <p className="mb-2 text-[0.85rem] uppercase tracking-[0.12em] text-black/60">
            Berlin · Software Developer
          </p>

          <h1 className="text-balance text-3xl font-semibold tracking-[-0.02em] text-black/90 sm:text-5xl lg:text-6xl">
            Reynaldo Domenico
          </h1>

          <p className="mt-3 sm:mt-5 text-[0.95rem] sm:text-[1.05rem] leading-relaxed text-black/75">
            I build calm, intuitive web applications with a focus on clarity,
            performance, and good product details.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.7, ease, delay: 0.1 }}
          className="flex flex-wrap items-center gap-3"
        >
          <a
            href="#project"
            className="inline-flex items-center gap-2 rounded-full bg-black/90 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-black"
            aria-label="View selected work"
          >
            View my work <ArrowDownRight size={16} />
          </a>

          <a
            href="#contact"
            className="inline-flex items-center gap-2 rounded-full border border-black/15 px-5 py-2.5 text-sm font-medium text-black/80 transition hover:border-black/30 hover:text-black"
            aria-label="Contact"
          >
            Get in touch <Mail size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default AppWrap(
  MotionWrap(Header, "app__header"),
  "home",
  "app__whitebg"
);
